export default __webpack_public_path__ + "static/media/special-defense.8f914c71.webp";